import HomeDesign1 from './HomeDesign1';

// Single active home variant. Design 1 (Swiss light + green) is the winner.
// Keeping the import indirection so we can A/B a new variant later without
// touching App.js routing again.
export default HomeDesign1;
